import * as a from '@mitranim/js/all.mjs'
import * as dr from '@mitranim/js/dom_reg.mjs'
import * as dg from '@mitranim/js/dom_global'
import * as u from './util.mjs'
import {A, E} from './util.mjs'
import * as d from './dat.mjs'
import * as ei from './elem-input.mjs'

/*
Semi-placeholder. Intended as a superclass for custom elements that implement
various types of form fields. This is supposed to be part of the process of
replacing React-based forms with native DOM forms.

TODO:

  * Provide an initialization method for rendering a fancy field with a label
    and an input.

  * Consolidate with `misc.mjs`→`FormFieldBase`.

Technical note. Subclassing `<fieldset>` makes it easier to disable inputs.
Fieldsets are automatically included into `HTMLFormElement..elements` and
support the `.disabled` getter-setter. Disabling a fieldset disables all
inner inputs, without having to disable them one by one. We can implement
`.onFormDisabled` at the level of this class without having to fiddle with
individual inputs.

TODO consider converting to mixin to make possible to change base class.
Don't always want fieldset.
*/
export class FormField extends ei.MixFormElem(u.MixElem(dg.global.HTMLFieldSetElement)) {
  static {dr.reg(this)}

  // TODO consolidate with React component `misc.mjs`→`FormFieldBase`,
  // which this is intended to replace.
  get A() {return A.cls(`col-sta-sta gap-sm`)}
  init() {return E(this, this.A)}

  get Label() {return FormFieldLabel}
  label() {return this.desc(this.Label) ?? this.desc(dg.global.HTMLLabelElement)}

  get Input() {throw u.errImplementInSubclass()}
  input() {return this.desc(this.Input) ?? this.desc(dg.global.HTMLInputElement)}

  getId() {
    return (
      this.input()?.id ||
      this.label()?.htmlFor ||
      (this.dataset.id ||= this.ctx.seq.nextId())
    )
  }

  // Native input elements don't emit this event by default.
  // Our own custom inputs can use `u.dispatchErr` to
  // generate error events localized to a fieldset.
  connectedCallback() {this.onerror = this.onError}
  onError({error: err}) {this.setErr(err)}
  setErr(err) {this.msg()?.setErr(err)}
  msg() {return u.sel(this, `form-msg`)}

  // Invoked by `Form`, particularly during form submission. Because this is
  // `<fieldset>`, this automatically disables native inner inputs.
  onFormDisabled(val) {this.disabled = a.laxBool(val)}
}

export function MixFormFieldElem(val) {return MixFormFieldElemCache.goc(val)}

class MixFormFieldElemCache extends a.DedupMixinCache {
  static make(cls) {
    return class MixFormFieldElemCls extends cls {
      field() {return this.anc(FormField)}
    }
  }
}

/*
TODO consolidate with React component `misc.mjs`→`FormFieldLabel`,
which this is intended to replace.

TODO: support activation on Enter for accessibility.
*/
export class FormFieldLabel extends MixFormFieldElem(u.MixElem(dg.global.HTMLLabelElement)) {
  static {dr.reg(this)}
  get A() {return A.cls(`form-label cur-point`)}

  initFromSpec(src) {
    src = a.toInst(src, d.UiField)
    return E(this, this.A, src.getTitleLong())
  }

  forDefault() {
    this.htmlFor ||= this.field()?.getId()
    return this
  }
}
